import * as React from "react";
import clsx from "clsx";
import { AnalyticsProvider } from "../../helpers/analytics/analytics-provider/analytics-provider.mjs";
const FeatureList = (props) => {
  const { className, children, analyticsGroup = "Features" } = props;
  return /* @__PURE__ */ React.createElement(AnalyticsProvider, { group: analyticsGroup }, /* @__PURE__ */ React.createElement("div", { className: clsx("feature-list", className) }, /* @__PURE__ */ React.createElement("ul", { className: "feature-list__inner" }, children)));
};
export {
  FeatureList
};
